// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_14n7bS","copy":"_3__2la","link":"MQeZNN"};